var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceiveText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.22,153.49c-43.13-34.18-68.69-73.33-121.58-87.81-44.24-12.11-66.36,6.75-78,41.2C54.1,191.77,132.68,285.37,228,325.09c90.25,37.63,162,7.26,182.62-67,7.81-28.06,7.1-76.95-39.1-90.72C337.6,157.24,319,182.61,282.22,153.49Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.22,153.49c-43.13-34.18-68.69-73.33-121.58-87.81-44.24-12.11-66.36,6.75-78,41.2C54.1,191.77,132.68,285.37,228,325.09c90.25,37.63,162,7.26,182.62-67,7.81-28.06,7.1-76.95-39.1-90.72C337.6,157.24,319,182.61,282.22,153.49Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-24"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-24",
    cx: 245,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.13,
    y: 170.22,
    width: 5.9,
    height: 1,
    transform: "translate(180.53 534.01) rotate(-86.3)",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.5,
    y: 153.05,
    width: 19.39,
    height: 1,
    transform: "translate(198.74 519.08) rotate(-86.31)",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.44,115.74H246.89A12.14,12.14,0,0,0,235,126.93l-15.19,234.5a10.4,10.4,0,0,0,10.47,11.2H347.81a12.16,12.16,0,0,0,11.92-11.2l15.18-234.5A10.39,10.39,0,0,0,364.44,115.74Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.71,115.74H246.89A12.14,12.14,0,0,0,235,126.93l-15.19,234.5a10.4,10.4,0,0,0,10.47,11.2H344.08A12.16,12.16,0,0,0,356,361.43l15.18-234.5A10.39,10.39,0,0,0,360.71,115.74Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.11,355.3H225.91a3.42,3.42,0,0,1-3.42-3.64l13.74-212.2a3.42,3.42,0,0,1,3.41-3.2H364.85a3.43,3.43,0,0,1,3.42,3.65L354.53,352.1A3.42,3.42,0,0,1,351.11,355.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.29,129.32H277.78a1.69,1.69,0,0,1-1.7-1.82h0a2,2,0,0,1,1.93-1.81h45.51a1.68,1.68,0,0,1,1.7,1.81h0A2,2,0,0,1,323.29,129.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.77,364.21a4.75,4.75,0,0,1-4.69,4.46,4.2,4.2,0,0,1-4.23-4.46,4.75,4.75,0,0,1,4.69-4.45A4.19,4.19,0,0,1,287.77,364.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.47,195H230.56l-6.8,104.9H337.47a11.22,11.22,0,0,0,11.2-11.19V206.23A11.22,11.22,0,0,0,337.47,195Z",
    style: {
      fill: "#E34B4B",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notification--inject-24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.29,
    y: 185.71,
    width: 153.42,
    height: 104.91,
    rx: 11.2,
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.71,184.5a1,1,0,0,1-.7-.29l-1.8-1.79a1,1,0,0,1,1.42-1.42l1.79,1.8a1,1,0,0,1,0,1.41A1,1,0,0,1,181.71,184.5Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,190.78h-2.53a1,1,0,0,1,0-2H179a1,1,0,0,1,0,2Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.08,181.8a1,1,0,0,1-1-.93l-.18-2.53a1,1,0,0,1,.93-1.07,1,1,0,0,1,1.06.93l.19,2.53a1,1,0,0,1-.93,1.07Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.19 279.83 313.42 320.05 313.42 279.83 273.19 279.83",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.22,262.21l-2-8.49a15.36,15.36,0,0,1,0-6.78L285,234.85a23.71,23.71,0,0,0-12.54-26.31,6.78,6.78,0,0,0,.23-.68,5.72,5.72,0,1,0-11.17-2.5,4.31,4.31,0,0,0-.09.71,23.72,23.72,0,0,0-22.57,18.44l-2.71,12.1a15.27,15.27,0,0,1-2.9,6.11l-5.39,6.85a5.06,5.06,0,0,0,2.87,8.06l47.5,10.64A5.05,5.05,0,0,0,284.22,262.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.35,264.83a2.25,2.25,0,0,0-2.7,2.59,8.21,8.21,0,0,0,14.83,3.32,2.25,2.25,0,0,0-1.33-3.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.87,248a1.48,1.48,0,0,1-1.25-.67,32.08,32.08,0,0,1,8.87-44.49,1.5,1.5,0,1,1,1.66,2.5,29.09,29.09,0,0,0-8,40.33,1.5,1.5,0,0,1-.41,2.08A1.52,1.52,0,0,1,211.87,248Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.22,243.74a1.5,1.5,0,0,1-1.24-.67,24.45,24.45,0,0,1,6.75-33.89,1.5,1.5,0,0,1,1.67,2.5,21.43,21.43,0,0,0-5.93,29.72,1.5,1.5,0,0,1-.41,2.08A1.54,1.54,0,0,1,218.22,243.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.58,239.49a1.48,1.48,0,0,1-1.24-.66A16.78,16.78,0,0,1,228,215.54a1.5,1.5,0,0,1,1.67,2.49,13.79,13.79,0,0,0-3.81,19.13,1.51,1.51,0,0,1-.41,2.08A1.52,1.52,0,0,1,224.58,239.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.35,269.09a1.5,1.5,0,0,1-.69-2.83,29.09,29.09,0,0,0,12.5-39.18,1.5,1.5,0,1,1,2.66-1.37A32.08,32.08,0,0,1,299,268.93,1.58,1.58,0,0,1,298.35,269.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.84,262.3a1.5,1.5,0,0,1-.69-2.83,21.42,21.42,0,0,0,9.21-28.88,1.5,1.5,0,0,1,2.67-1.38,24.42,24.42,0,0,1-10.5,32.92A1.44,1.44,0,0,1,294.84,262.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.33,255.51a1.51,1.51,0,0,1-.69-2.84,13.77,13.77,0,0,0,5.93-18.57,1.5,1.5,0,0,1,2.67-1.38A16.81,16.81,0,0,1,292,255.34,1.53,1.53,0,0,1,291.33,255.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.36,125.85h-7.64a.84.84,0,0,0-.81.72l-1.6,15.24a.65.65,0,0,0,.65.73h7.64a.84.84,0,0,0,.81-.73l1.6-15.24A.64.64,0,0,0,203.36,125.85Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.67,125.85h-6.95a.84.84,0,0,0-.81.72l-1.6,15.24a.65.65,0,0,0,.65.73h7a.83.83,0,0,0,.8-.73l1.6-15.24A.63.63,0,0,0,202.67,125.85Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.07,407.65c1,0,2-.15,2.35-.61a.74.74,0,0,0,0-.84,1.06,1.06,0,0,0-.63-.45c-1.36-.37-4.12,1.25-4.24,1.32a.18.18,0,0,0-.08.19.2.2,0,0,0,.16.16A14.56,14.56,0,0,0,165.07,407.65Zm1.22-1.57a1.45,1.45,0,0,1,.37,0,.66.66,0,0,1,.39.27c.14.24.1.36,0,.42-.35.53-2.4.54-3.91.33A8.21,8.21,0,0,1,166.29,406.08Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.61,407.42h.08c1-.44,2.82-2.19,2.63-3.11,0-.21-.21-.48-.74-.53a1.39,1.39,0,0,0-1.05.32c-1,.85-1.11,3-1.12,3.12a.21.21,0,0,0,.09.18A.2.2,0,0,0,162.61,407.42Zm1.84-3.28h.11c.35,0,.38.17.38.21.12.55-1.14,1.93-2.11,2.53a4.36,4.36,0,0,1,1-2.5A1,1,0,0,1,164.45,404.14Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.69,
    y: 388.48,
    width: 8.1,
    height: 18.75,
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.95 398.29 103.04 399.17 108.31 380.97 100.22 380.09 94.95 398.29",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8,401c1,.26,2,.37,2.45,0a.71.71,0,0,0,.16-.82,1,1,0,0,0-.5-.58c-1.25-.69-4.35.18-4.48.21a.19.19,0,0,0-.14.17.21.21,0,0,0,.12.19A14.86,14.86,0,0,0,106.8,401Zm1.58-1.2a1.59,1.59,0,0,1,.35.13.63.63,0,0,1,.32.35c.08.27,0,.37,0,.43-.48.41-2.49-.08-3.92-.66A8.42,8.42,0,0,1,108.38,399.81Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.45,400.19h.08c1-.19,3.3-1.41,3.34-2.33,0-.22-.08-.52-.59-.7a1.43,1.43,0,0,0-1.11.06c-1.18.57-1.84,2.63-1.87,2.71a.19.19,0,0,0,0,.19A.17.17,0,0,0,104.45,400.19Zm2.6-2.69.12,0c.33.12.32.26.32.3,0,.56-1.6,1.57-2.7,1.9a4.25,4.25,0,0,1,1.56-2.15A1,1,0,0,1,107.05,397.5Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.47,398.42l-8.85-2.54a.68.68,0,0,0-.8.34l-3.26,6.47a1.23,1.23,0,0,0,.81,1.71c3.1.83,4.65,1.09,8.54,2.2,2.39.69,7.26,2.35,10.57,3.3s4.53-2.16,3.25-2.84c-5.74-3.05-7.58-5.51-9.1-7.79A2.07,2.07,0,0,0,103.47,398.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.7,406.29h-8.84a.66.66,0,0,0-.66.56L150.91,414a1.25,1.25,0,0,0,1.23,1.45c3.19-.06,7.79-.25,11.8-.25,4.69,0,7.25.26,12.75.26,3.32,0,4.1-3.36,2.69-3.67-6.39-1.38-10.08-1.53-15.7-4.91A4,4,0,0,0,161.7,406.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.69,
    y: 388.48,
    width: 8.1,
    height: 9.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.22 380.1 108.31 380.97 105.38 391.07 97.5 389.48 100.22 380.1",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,202S144,263.14,140,286.32c-4.41,25.39-30.07,103.13-30.07,103.13l-14.7-2.69s18.53-73,20.58-98.14c2.23-27.28,4.91-83.51,4.91-83.51Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.94,227.4c.8-3.36,2.64.87,4.78,8.2-1.62,18.14-3.73,39.15-5.75,50.73-.45,2.59-1.13,5.73-2,9.29C138.74,269.74,138.77,236.49,140.94,227.4Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.74,200.34s5.87,61.46,6.07,86.15c.21,25.69-5.08,109.79-5.08,109.79H151s-4.12-82.6-5.83-107.83c-1.87-27.5-9.74-85-9.74-85Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,384.5c.06,0-2.31,5.33-2.31,5.33l-16.54-3,1-4.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.13,390.81c.06,0-.53,5.7-.53,5.7H149.92l-.68-5.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.12,145.56c-1.1,2.13-2.31,4.37-3.41,6.58l-3.36,6.66c-1.09,2.22-2.16,4.45-3.19,6.68s-2,4.45-2.83,6.67l-.08-3.5a43.33,43.33,0,0,0,2.1,5.26c.39.88.89,1.72,1.32,2.59s1,1.7,1.51,2.52a57.84,57.84,0,0,0,3.44,4.91c.62.79,1.24,1.6,1.9,2.36s1.38,1.55,2,2.2l.2.22a2.88,2.88,0,0,1-3.54,4.45,32.94,32.94,0,0,1-3-1.91c-1-.66-1.88-1.35-2.78-2.08a47.79,47.79,0,0,1-5.06-4.81,43.81,43.81,0,0,1-4.35-5.62,43,43,0,0,1-3.46-6.38,4.31,4.31,0,0,1-.21-3l.14-.47c.76-2.61,1.61-5.14,2.55-7.62s1.94-4.91,3-7.3,2.17-4.75,3.34-7.08,2.35-4.61,3.7-6.94a5.8,5.8,0,0,1,10.18,5.56Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.86,142c.4,7.63-8.26,21.64-8.26,21.64l-17.83-8.91a52.49,52.49,0,0,1,9.88-17.23C120.08,127.08,126.49,135,126.86,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78,191.73l3.59,6,7.47-4.78a12.1,12.1,0,0,0-5.81-5.23,2.5,2.5,0,0,0-3,1.27Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.36,200.29l3.47-.65a2.25,2.25,0,0,0,1.8-2.64l-.79-4-7.47,4.78.5,1.21A2.24,2.24,0,0,0,121.36,200.29Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.43,103.66c.07.65.48,1.16.9,1.12s.7-.59.62-1.24-.48-1.16-.9-1.13S142.35,103,142.43,103.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.85,104.82a25.16,25.16,0,0,0,3.75,5.36c-1,1.17-3,.83-3,.83Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.63,100.21a.35.35,0,0,0,.29-.09,2.9,2.9,0,0,1,2.63-.71.36.36,0,0,0,.46-.26.4.4,0,0,0-.27-.48,3.69,3.69,0,0,0-3.34.86.38.38,0,0,0,0,.55A.34.34,0,0,0,139.63,100.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.27,110.9c1.91,5.79,4.45,16.46.83,20.74,0,0,2.38,5.83,13.34,4.9,12.07-1,5-6.45,5-6.45-6.78-1-7.24-5.89-6.68-10.56Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.51,133.75c-1.13-1.81-2.39-3.88-.25-4.65,2.35-.85,15.55-2.23,20.25-1.07s3.74,5,3.74,5Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.16,136.19c1.72,1.58,3.58,3.33,5.43,4.93s3.72,3.24,5.6,4.82,3.8,3.07,5.73,4.52,3.89,2.77,5.85,4l-4-.38a14.93,14.93,0,0,0,4.65-2.15A30.48,30.48,0,0,0,187,148a52.8,52.8,0,0,0,4.21-4.87c.67-.87,1.34-1.75,2-2.66s1.26-1.87,1.81-2.71l.11-.16a2.89,2.89,0,0,1,5.19,2.4c-.38,1.3-.78,2.41-1.24,3.57s-.94,2.3-1.48,3.42a46.21,46.21,0,0,1-3.83,6.55,34.3,34.3,0,0,1-5.3,6,23.38,23.38,0,0,1-7.55,4.52,4.78,4.78,0,0,1-3.68-.21l-.33-.17a72.07,72.07,0,0,1-7.22-4.08c-2.27-1.47-4.47-3-6.59-4.64s-4.17-3.3-6.17-5-3.92-3.48-5.87-5.47a5.8,5.8,0,0,1,8.05-8.34Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.05,131s10.08,9.78,11.25,70.27c-16.12,3.91-31.63,5.35-43.61,3.83-.57-7.59-1.42-33.93-9.12-61.7a8.77,8.77,0,0,1,6.79-11c1.53-.3,3.14-.57,4.74-.78a159.41,159.41,0,0,1,18.34-1.55A81.21,81.21,0,0,1,153.05,131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.23,141.54c1,7.57,14,22.12,14,22.12l15.43-16a126.61,126.61,0,0,0-14.82-13.29C148.53,125.92,144.33,134.52,145.23,141.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.32,142.66l5.16-4.73-6.18-6.35a12.1,12.1,0,0,0-4,6.74A2.5,2.5,0,0,0,196.2,141Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.38,134.49l-1.33-3.27a2.26,2.26,0,0,0-3-1.23l-3.79,1.59,6.18,6.35,1.08-.73A2.25,2.25,0,0,0,206.38,134.49Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.73,104c1.45,8,1.89,12.74,6.39,16.55,6.77,5.73,16.11,1.27,17-6.9.84-7.36-1.67-19.21-9.81-21.79S119.28,96,120.73,104Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.5,106.88c2.81.64,5-2.61,5.3-3.53-1.37.13-3.8-.57-4.28-1.19,1.5.13,2.95-1.72,3.13-2.43a6.24,6.24,0,0,1-3.93-2.55c2.43-.05,5.35-4.33,2.68-8.16S125.57,88.4,124,85.67c-2.34,1.36-.26,3.17-.26,3.17s-15.79,3-8.51,9.09c-5.34.48-6.09,6.79-1.64,10s4.68,5.33,2.91,5.07c.71,1.36,3.88,1.54,4.06.22.75,2.77,2.91,6.52,7.89,5.91S138.31,111.55,136.5,106.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.61,97c-3.76.52-5.47-1.6-4.53-3.47C107.42,95.91,112.51,101.17,116.61,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.61,105.66a8.8,8.8,0,0,0,3.28,4.12c2,1.32,3.81,0,3.47-2-.31-1.84-1.72-4.75-3.8-5.27A2.38,2.38,0,0,0,132.61,105.66Z",
    style: {
      fill: "#ff8b7b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.78,387.52c-7.4-17.46-10.39-38-1.92-37.15,8.69.84,7.67,31.8,9.08,35.2C391.23,387.9,386.78,387.52,386.78,387.52Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.18,354.39c-1.82,6.66-3.75,16.95-5.22,25.67.84,2.5,1.79,5,2.82,7.46,0,0,4.44.38,7.17-1.95C392.83,382.89,393.23,363.05,389.18,354.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.22,384.32c-2.32-37.1,4-71.49,20.64-69.94,14.28,1.34-6.54,63.8-6.14,71C397.18,387.92,389.22,384.32,389.22,384.32Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,384.08c2.61-26.67,16.68-57.79,22.72-47.39,7.67,13.2-12,44.64-12.53,49.81C405.27,387.56,400,384.08,400,384.08Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.37,324.29c-1.69-.28-2.63-1.33-2.52-2.82.12-1.68,1.5-3.35,2.78-3.37.62,0,1.66.32,1.92,2.63l-1,.12c-.12-1.1-.45-1.75-.89-1.75h0c-.68,0-1.72,1.24-1.8,2.44-.07,1,.49,1.56,1.68,1.76Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.33,331a3.79,3.79,0,0,1-2-.77l.54-.83c.93.6,1.65.76,1.93.42.42-.54.13-2.12-.74-2.95-.7-.67-1.52-.62-2.43.18l-.65-.76a2.61,2.61,0,0,1,3.77-.14c1.22,1.16,1.63,3.28.83,4.29A1.48,1.48,0,0,1,415.33,331Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.82,346.1a2.49,2.49,0,0,1-2.62-2c-.4-1.63.4-3.64,1.62-4.06.57-.19,1.67-.21,2.63,1.92l-.92.42c-.45-1-1-1.54-1.39-1.39-.64.22-1.25,1.71-1,2.87.23,1,1,1.34,2.14,1.16l.15,1A3.59,3.59,0,0,1,390.82,346.1Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.17,366.81a2.42,2.42,0,0,1-2.29-1.49c-.7-1.53-.29-3.66.82-4.3.53-.3,1.61-.52,2.95,1.4l-.82.57c-.64-.91-1.25-1.32-1.63-1.1-.59.34-.91,1.92-.41,3,.41.89,1.19,1.13,2.32.73l.33.95A3.72,3.72,0,0,1,380.17,366.81Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.89,336.62a.52.52,0,0,1-.29-.09,2.94,2.94,0,0,1-1.32-3.63,3.37,3.37,0,0,1,3.49-2c.62.11,2.07.66,2.17,3.32a.5.5,0,0,1-1,0c-.06-1.39-.53-2.23-1.35-2.38a2.4,2.4,0,0,0-2.39,1.43c-.36.85,0,1.71,1,2.42a.5.5,0,0,1-.29.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.74,363.61a.48.48,0,0,1-.48-.4.49.49,0,0,1,.38-.59c1.36-.28,2.11-.89,2.13-1.72a2.41,2.41,0,0,0-1.81-2.12c-.9-.22-1.7.27-2.23,1.37a.5.5,0,1,1-.9-.44,3,3,0,0,1,3.36-1.91,3.4,3.4,0,0,1,2.58,3.11c0,.63-.32,2.15-2.92,2.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.8,355.18c-.58,0-1.35-.34-2.21-1.63l.83-.56c.62.92,1.21,1.34,1.6,1.13.6-.32,1-1.9.47-3-.38-.89-1.16-1.15-2.3-.78l-.31-.95c1.62-.53,2.94,0,3.53,1.34.67,1.54.22,3.66-.91,4.27A1.39,1.39,0,0,1,423.8,355.18Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.82,393.87a22.23,22.23,0,0,0-5.39-14.54,1.45,1.45,0,0,0,1.24-1.42,1.48,1.48,0,0,0-1.48-1.47H381.71a1.46,1.46,0,0,0-.22,2.9A22.32,22.32,0,0,0,388,413.65a1.62,1.62,0,0,0,.75,3.06h19.39a1.63,1.63,0,0,0,1.62-1.62,1.64,1.64,0,0,0-.87-1.44A22.36,22.36,0,0,0,420.82,393.87Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveText);
export default __webpack_public_path__ + "static/media/receiveText.057cdd39cf725c4b7a16bce736b4f731.svg";
export { ForwardRef as ReactComponent };